import { Chip } from "@mui/material"
import type { FC } from "react"

interface PaymentTermsDisplayProps {
  name: string
  value: string | number | null
}

const PaymentTermsDisplay: FC<PaymentTermsDisplayProps> = ({ name, value }) => {
  return (
    <div className='flex flex-1 gap-1 [&:not(:last-child)]:mb-1'>
      <span className='w-[185px] text-sm text-gray-900'>{name}</span>
      {value && (
        <Chip
          label={value}
          variant='filled'
          size='small'
          className='rounded-[4px] bg-primary-200 text-xs hover:bg-primary-300'
        />
      )}
    </div>
  )
}

export default PaymentTermsDisplay
